<template>
  <div class="home_container">
    <TopNav />

    <div class="landing-hero">
      <video
        ref="heroVideo"
        class="landing-hero__video"
        poster="/images/poster-hero.webp"
        autoplay
        muted
        playsinline
        aria-hidden="true"
      >
        <source src="/images/vid-hero-4.webm" type="video/webm" />
      </video>
      <div aria-hidden="true"></div>
      <div class="container landing-hero__content">
        <div class="row landing-text-box">
          <div>
            <h3>PERINGATAN</h3>
            <p class="text-white">
              Segala bentuk transaksi aset kripto memiliki risiko dan berpeluang
              untuk mengalami kerugian (High Risk, High Return). Nilai aset
              kripto sangat fluktuatif, di mana harga dapat berubah secara
              drastis dari waktu ke waktu. Harap lakukan riset mendalam (DYOR)
              dan pastikan keputusan transaksi sesuai dengan profil risiko serta
              kemampuan finansial Anda.
            </p>
            <div class="d-flex justify-content-center" id="auth_menu_button">
              <router-link
                to="/auth/register"
                class="btn btn-lg btn-outline-orange"
              >
                DAFTAR
              </router-link>
              <router-link
                to="/auth/login"
                class="btn btn-lg btn-outline-yellow"
              >
                MASUK
              </router-link>
            </div>
            <div id="logged_menu_button">
              <router-link
                :to="themain.defaultMarketPair"
                class="btn btn-lg btn-outline-yellow"
                style="color: #c1a15b"
              >
                Pertukaran
              </router-link>
            </div>
          </div>

          <div class="offset-md-1 col-md-3">
            <!-- TradingView Widget BEGIN -->
            <div
              class="tradingview-widget-container tradingview-tecnical-analys"
            >
              <div class="tradingview-widget-container__widget"></div>
            </div>
            <!-- TradingView Widget END -->
          </div>
        </div>
      </div>
    </div>

    <div class="container popular-markets">
      <h2>Pasar Terpopuler</h2>

      <MarketTable />
    </div>

    <div class="landing-info-one landing-info-one-bg mtb100">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <h2>Mengapa harus menggunakan Pegasus Exchange</h2>
            <p>
              Ketika kita bekerja bersama, pintu keuntungan akan terbuka lebar.
            </p>
            <ul>
              <li>
                <i class="icon ion-ios-checkmark-circle"></i> Mudah untuk
                digunakan
              </li>
              <li>
                <i class="icon ion-ios-checkmark-circle"></i> Biaya rendah
              </li>
              <li>
                <i class="icon ion-ios-checkmark-circle"></i> Transparansi
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <img src="/images/pgx-robot.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
// node_modules
import Cookies from "js-cookie";

// applibs
import themain from "@/applibs/themain.js";
import thestore from "@/applibs/thestore.js";

// components
import TopNav from "@/components/global/TopNav.vue";
import Footer from "@/components/global/Footer.vue";
import MarketTable from "@/components/global/MarketTable.vue";

export default {
  components: {
    TopNav,
    Footer,
    MarketTable,
  },

  data() {
    return {
      themain,

      token: Cookies.get("jwt") || Cookies.get("usid"),
      usid: Cookies.get("usid"),
      heroVideoEndedHandler: null,
    };
  },

  sockets: {
    connect: function () {
      console.log("socket connected");
    },

    market_update: function (data) {
      var self = this;

      var market = data.market;

      self.emitter.emit("fe-market_update", {
        data: market,
      });
    },
  },

  async beforeMount() {
    var self = this;

    // cek expire token
    if (self.token) {
      var res = await thestore.postCheckToken(self.token);
      if (res.success == false) {
        Cookies.remove("jwt");
        Cookies.remove("usid");
        self.$router.go();
      }
    }
  },

  mounted() {
    var self = this;

    const authMenuButton = document.getElementById("auth_menu_button");
    const loggedMenuButton = document.getElementById("logged_menu_button");
    if (self.token) {
      if (authMenuButton) {
        authMenuButton.style.visibility = "hidden";
        loggedMenuButton.style.visibility = "visible";
      }
    } else if (authMenuButton) {
      authMenuButton.style.visibility = "visible ";
      loggedMenuButton.style.visibility = "hidden";
    }

    self.$nextTick(function () {
      var video = self.$refs.heroVideo;
      if (video) {
        video.playbackRate = 1.3;
        self.heroVideoEndedHandler = function () {
          video.classList.add("landing-hero__video--zoom-loop");
          video.pause();
          video.currentTime = video.duration || video.currentTime;
        };
        video.addEventListener("ended", self.heroVideoEndedHandler);
      }
    });
  },

  beforeUnmount() {
    var self = this;
    var video = self.$refs.heroVideo;

    if (video && self.heroVideoEndedHandler) {
      video.removeEventListener("ended", self.heroVideoEndedHandler);
    }
  },
};
</script>

<style scoped>
.home_container {
  position: relative;
}

.landing-hero {
  position: relative;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  margin: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.landing-hero__video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 0;
}

.landing-hero__video--zoom-loop {
  animation: landingHeroZoomLoop 9s ease-in-out infinite;
}

@keyframes landingHeroZoomLoop {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.landing-hero__overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.landing-hero__content {
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.landing-text-box {
  text-align: center;
  background-color: #00000097;
  -webkit-backdrop-filter: blur(15px);
  backdrop-filter: blur(15px);
  width: 40%;
  padding: 50px 40px;
  border-radius: 16px;
  /* border: 2px solid #cda759; */
}

.btn-outline-orange {
  color: #fff;
  padding: 12px 30px;
  border: 1px solid #fff;
  margin-right: 20px;
  box-shadow: 0 0 15px #ff666d;
  /* background-color: #ff666d; */
}

.btn-outline-yellow {
  color: #fff;
  padding: 12px 30px;
  border: 1px solid #fff;
  margin-right: 20px;
  box-shadow: 0 0 15px #ffc070;
  /* background-color: #ffc070; */
}

.landing-hero p {
  font-size: 14px;
}

.popular-markets h2 {
  margin: 50px 0px 50px 0px;
  color: #fff;
}

@media only screen and (max-width: 767px) {
  .landing-hero__content {
    padding: 24px 12px;
  }

  .landing-text-box {
    width: 90%;
    padding: 40px 24px;
  }

  .landing-text-box h3 {
    color: #fff;
    font-size: 1.5rem;
    line-height: 1.25;
  }

  .landing-hero p {
    font-size: 15px;
  }

  #auth_menu_button {
    gap: 12px;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
  }

  #logged_menu_button {
    display: flex;
    justify-content: center;
  }

  .btn-outline-orange,
  .btn-outline-yellow {
    padding: 8px 20px;
    margin-right: 0;
    font-size: 1rem;
  }

  .btn-outline-orange,
  .btn-outline-yellow,
  #logged_menu_button .btn {
    width: min(100%, 240px);
  }
}
</style>
